<template>
  <div class="tw-fixed tw-top-4 tw-right-4 tw-z-20">
    <button
      class="btn-reiniciar tw-px-6 tw-py-4 tw-bg-white tw-shadow-lg tw-font-semibold tw-justify-center tw-items-center tw-flex tw-rounded-md tw-text-2xl"
      @click="abrirConfirmacao"
    >
      <v-icon color="#8c2667" size="30">mdi-sync</v-icon>
      <div class="tw-ml-2 tw-text-gray-800">{{ getTitle }}</div>
    </button>

    <div
      v-if="dialogVisivel"
      class="privacy-popup-overlay"
      @click.self="dialogVisivel = false"
    >
      <div class="privacy-popup-content" @click.stop>
        <div class="privacy-popup-header">
          <h2 class="privacy-popup-title">Reiniciar operação</h2>
        </div>
        <div class="privacy-popup-body">
          <p>
            Ao reiniciar, você retornará à tela inicial e precisará começar
            novamente.
          </p>
        </div>
        <div class="privacy-popup-footer">
          <button
            type="button"
            class="privacy-popup-button privacy-popup-button-secondary"
            @click="dialogVisivel = false"
          >
            Cancelar
          </button>
          <button
            type="button"
            class="privacy-popup-button"
            @click="confirmarReinicio"
          >
            Sim, reiniciar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setEtapaCompra } from "@/service/firebase";
export default {
  data() {
    return {
      dialogVisivel: false,
    };
  },
  computed: {
    getCompra() {
      return this.$store.getters["compra/getCompra"];
    },
    isBuyFinish() {
      return (
        this.getCompra?.etapa === "AGRADECIMENTO" ||
        this.getCompra?.etapa === "IMPRESSAO"
      );
    },
    getTitle() {
      return this.isBuyFinish ? "Finalizar" : "Reiniciar";
    },
  },
  methods: {
    abrirConfirmacao() {
      this.dialogVisivel = true;
    },
    confirmarReinicio() {
      this.dialogVisivel = false;
      this.ReiniciarOuFinalizar();
    },
    ReiniciarOuFinalizar() {
      if (this.isBuyFinish) {
        setEtapaCompra("AGRADECIMENTO");
        this.$router.push("/cabine/home");
        return;
      }
      this.$root.SairDaCompra("CANCELADA");
    },
  },
};
</script>

<style scoped>
/* Popup idêntico ao de Política de Privacidade (scanQrCode.vue) */
.privacy-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.privacy-popup-content {
  background: white;
  border-radius: 16px;
  padding: 0;
  max-width: 90vw;
  width: 560px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
}

.privacy-popup-header {
  width: 100%;
  padding: 24px;
  text-align: center;
  background: linear-gradient(180deg, #8c2667 0%, #222129 100%);
}

.privacy-popup-title {
  color: white;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
}

.privacy-popup-body {
  padding: 28px 24px;
}

.privacy-popup-body p {
  font-size: 16px;
  line-height: 1.6;
  color: #444;
  margin: 0 0 12px 0;
}

.privacy-popup-body p:last-of-type {
  margin-bottom: 0;
}

.privacy-popup-footer {
  padding: 20px 24px 24px;
  display: flex;
  justify-content: center;
  gap: 16px;
}

.privacy-popup-button {
  background: linear-gradient(135deg, #8c2667, #651946);
  color: white;
  border: none;
  padding: 16px 32px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.privacy-popup-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(140, 38, 103, 0.4);
}

.privacy-popup-button-secondary {
  background: #e5e7eb;
  color: #374151;
}

.privacy-popup-button-secondary:hover {
  background: #d1d5db;
  transform: none;
  box-shadow: none;
}

.btn-reiniciar {
  color: #1f2937;
}

.btn-reiniciar:hover {
  background-color: #f9fafb;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
}
</style>
